import { render, staticRenderFns } from "./BookIcon.vue?vue&type=template&id=d2d8b450&"
import script from "./BookIcon.vue?vue&type=script&lang=js&"
export * from "./BookIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports